import React, { useState } from 'react'
import { connect } from 'react-redux'
import { ArticleCreateEditForm } from 'containers'
import { articles } from 'redux/modules'
import { createSubUrl } from 'utils/urlConstructor'
import { toast } from 'react-toastify'
import PropTypes from 'prop-types'
import { ARTICLES_DASHBOARD_ROUTE } from 'constants/routes'

const ArticleCreateContainer = ({
  history,
  match,
  location: { fromUrl, fromPathname = 'Articles' },
  articlesCategories,
  createArticle,
}) => {
  const linkBack = fromUrl || createSubUrl(match, ARTICLES_DASHBOARD_ROUTE)

  const goBack = () => history.push(linkBack)
  const [selectedType, setSelectedType] = useState('article')

  const onSubmit = (values) => {
    let data = { ...values }

    data.categories = data.categories
      .map((uuid) => {
        const matchedCategory = articlesCategories.find(
          (cat) => cat.uuid === uuid
        )

        return matchedCategory ? matchedCategory.id : null
      })
      .filter((id) => id !== null)

    if (selectedType === 'video') {
      delete data.podcast
      delete data.body

      // @tofix Fix validation using JOI if possible.
      if (!data.video) {
        toast.error('Select a video first')

        return
      }
    } else if (selectedType === 'podcast') {
      delete data.video
      delete data.body

      // @tofix Fix validation using JOI if possible.
      if (!data.podcast) {
        toast.error('Select an audio first')

        return
      }
    } else {
      delete data.video
      delete data.podcast

      // @tofix Fix validation using JOI if possible.
      if (!data.body) {
        toast.error('Please explain the article content')

        return
      }
    }
    data = { ...data, type: selectedType }

    createArticle(data).then(goBack)
  }

  return (
    <ArticleCreateEditForm
      form="articleCreate"
      fromPath={{
        value: linkBack,
        title: fromPathname,
      }}
      initialValues={{
        categories: [],
      }}
      onSubmit={onSubmit}
      articlesCategories={articlesCategories}
      setSelectedType={setSelectedType}
    />
  )
}

ArticleCreateContainer.defaultProps = {
  articlesCategories: [],
}

ArticleCreateContainer.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.objectOf(PropTypes.string).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    fromUrl: PropTypes.string,
    fromPathname: PropTypes.string,
  }).isRequired,
  articlesCategories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      parent_id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      uuid: PropTypes.string.isRequired,
    })
  ),
  createArticle: PropTypes.func.isRequired,
}

export default connect(
  ({
    articles: {
      current: { articlesCategories },
    },
  }) => ({ articlesCategories }),
  {
    createArticle: articles.createArticle,
  }
)(ArticleCreateContainer)
